<div class="overflow-hidden">
  <div
    fxLayout="row wrap"
    fxLayoutGap="20px"
    class="px-20 py-8 justify-between"
  >
    <div class="flex flex-wrap justify-center items-center">
      <!-- En attente de sortie -->
      <div
        [matBadge]="getLatePackages(departColis)"
        matBadgePosition="after"
        matBadgeColor="warn"
        [matBadgeHidden]="getLatePackages(departColis) <= 0"
        [style]="
          selectedOption == 1 ? 'background: #ff4a4a' : 'background: white'
        "
        class="mt-10 mr-16 cursor-pointer shadow-lg p-8 rounded-lg"
        style="width: 150px"
        (click)="selectOption(1)"
      >
        <div>
          <div
            class="font-bold text-center"
            [style]="selectedOption != 1 ? 'color: #ff4a4a' : 'color: white'"
          >
            En attente de sortie
          </div>
          <div
            class="font-size-28 text-center px-4 py-8"
            [style]="selectedOption != 1 ? 'color: #ff4a4a' : 'color: white'"
          >
            {{ departColis.length }}
          </div>
        </div>
      </div>
      <!-- En circulation -->
      <div
        [matBadge]="getLatePackages(encourColis)"
        matBadgePosition="after"
        matBadgeColor="warn"
        [matBadgeHidden]="getLatePackages(encourColis) <= 0"
        [style]="
          selectedOption == 2 ? 'background: #03d692' : 'background: white'
        "
        class="mt-10 mx-16 cursor-pointer shadow-lg p-8 rounded-lg"
        style="width: 150px"
        (click)="selectOption(2)"
      >
        <div>
          <div
            class="text-center font-bold"
            [style]="selectedOption != 2 ? 'color: #03d692' : 'color: white'"
          >
            En circulation
          </div>
          <div
            class="font-size-28 text-center px-4 py-8"
            [style]="selectedOption != 2 ? 'color: #03d692' : 'color: white'"
          >
            {{ encourColis.length }}
          </div>
        </div>
      </div>
      <!-- Arrivées -->
      <div
        [style]="
          selectedOption == 3 ? 'background: #7e54ff' : 'background: white'
        "
        class="mt-10 mx-16 cursor-pointer shadow-lg p-8 rounded-lg"
        style="width: 150px"
        (click)="selectOption(3)"
      >
        <div>
          <div
            class="text-center font-bold"
            [style]="selectedOption != 3 ? 'color: #7e54ff' : 'color: white'"
          >
            Arrivées
          </div>
          <div
            class="font-size-28 text-center px-4 py-8"
            [style]="selectedOption != 3 ? 'color: #7e54ff' : 'color: white'"
          >
            {{ arriveColis.length }}
          </div>
        </div>
      </div>
    </div>
    <!-- buttons -->
    <div class="flex">
      <button
        mat-raised-button
        class="float-right m-4 h-40 bg-green-800 text-white"
        (click)="ngOnInit()"
      >
        Rafraîchir
      </button>
      <button
        mat-raised-button
        color="primary"
        class="float-right m-4 h-40"
        (click)="startListening()"
      >
        scanner un colis
      </button>
    </div>
  </div>

  <!-- filter -->
  <mat-expansion-panel
    class="mx-20"
    style="box-shadow: none"
    (opened)="panelOpenState = true"
    (closed)="panelOpenState = false"
  >
    <mat-expansion-panel-header class="bg-gray-800 hover:bg-gray-800">
      <mat-panel-title>
        <div class="text-2xl text-white">Filters</div>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="flex mb-12 pt-5">
      <span
        (click)="toggleFilter()"
        class="cursor-pointer text-lg rounded-lg px-16 py-8 whitespace-no-wrap text-white font-bold h-48 flex justify-center items-center"
        style="width: 120px"
        [class]="filterOn ? 'bg-green-800' : 'bg-red-800'"
        >{{ filterOn ? "Filtre activé" : "Filtre désactivé" }}</span
      >
      <span
        (click)="clearFilter()"
        class="cursor-pointer text-lg rounded-md whitespace-no-wrap px-16 ml-4 py-8 text-yellow-600 border-2 border-yellow-600 hover:text-white hover:bg-yellow-600 font-bold h-48 flex justify-center items-center"
        style="width: 140px"
        >Effacer filtre</span
      >
    </div>

    <div
      class="grid sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 my-4 lg:gap-x-4 md:gap-x-16 gap-y-4"
    >
      <!-- depart -->
      <div
        class="flex transition h-48"
        [class]="filterOn ? '' : 'opacity-70 pointer-events-none'"
      >
        <span
          style="min-width: 126px"
          class="text-center text-lg rounded-l-md px-16 py-8 bg-gray-300 whitespace-no-wrap text-gray-600 font-bold"
          >Départ:</span
        >
        <input
          name="field_name"
          class="border-2 rounded-r-md px-4 p-8 border-gray-300 font-bold text-gray-700"
          type="text"
          [disabled]="!filterOn"
          [(ngModel)]="FilterDepart"
          placeholder="Filtrer avec départ"
          (keyup)="updateFilter()"
        />
      </div>
      <!-- arrivee -->
      <div
        class="flex transition h-48"
        [class]="filterOn ? '' : 'opacity-70 pointer-events-none'"
      >
        <span
          style="min-width: 126px"
          class="text-center text-lg rounded-l-md px-16 py-8 bg-gray-300 whitespace-no-wrap text-gray-600 font-bold"
          >Arrivée:</span
        >
        <input
          name="field_name"
          class="border-2 rounded-r-md px-4 p-8 border-gray-300 font-bold text-gray-700"
          type="text"
          [(ngModel)]="FilterArrive"
          [disabled]="!filterOn"
          placeholder="Filtrer avec Arrivée"
          (keyup)="updateFilter()"
        />
      </div>
      <!-- reference -->
      <div
        class="flex transition h-48"
        [class]="filterOn ? '' : 'opacity-70 pointer-events-none'"
      >
        <span
          style="min-width: 126px"
          class="text-center text-lg rounded-l-md px-16 py-8 bg-gray-300 whitespace-no-wrap text-gray-600 font-bold"
          >Référence:</span
        >
        <input
          name="field_name"
          class="border-2 rounded-r-md px-4 p-8 border-gray-300 font-bold text-gray-700"
          type="text"
          [(ngModel)]="FilterReference"
          [disabled]="!filterOn"
          placeholder="Filtrer avec référence"
          (keyup)="updateFilter()"
        />
      </div>
      <!-- code a bar -->
      <div
        class="flex transition h-48"
        [class]="filterOn ? '' : 'opacity-70 pointer-events-none'"
      >
        <span
          style="min-width: 125px; font-size: 16px"
          class="text-center text-lg rounded-l-md px-16 py-8 bg-gray-300 whitespace-no-wrap text-gray-600 font-bold"
          >Code a barre :</span
        >
        <input
          name="field_name"
          class="border-2 rounded-r-md px-4 p-8 border-gray-300 font-bold text-gray-700"
          type="text"
          [(ngModel)]="FilterCode"
          [disabled]="!filterOn"
          placeholder="Filtrer avec code a barre"
          (keyup)="updateFilter()"
        />
      </div>
      <!-- date -->
      <div
        class="flex transition h-48"
        [class]="filterOn ? '' : 'opacity-70 pointer-events-none'"
      >
        <mat-form-field appearance="outline" class="h-0 w-full">
          <mat-label>Filtrer avec date de Départ</mat-label>
          <input
            matInput
            [matDatepicker]="picker"
            [(ngModel)]="FilterDate"
            (dateChange)="updateFilter()"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>
      <!-- Nombre de jours (Arrive) -->
      <div
        class="flex transition h-48 md:col-span-1 lg:col-span-2"
        [class]="filterOn ? '' : 'opacity-70 pointer-events-none'"
      >
        <span
          style="min-width: 170px"
          class="text-center text-lg rounded-l-md px-16 py-8 bg-gray-300 whitespace-no-wrap text-gray-600 font-bold"
          >Nombre de jours:</span
        >
        <input
          name="field_name"
          class="border-2 px-4 p-8 border-gray-300 font-bold text-gray-700 border-r-0"
          type="number"
          [disabled]="!filterOn"
          placeholder="Exp: 1"
          [(ngModel)]="historyDays"
        />
        <div
          class="cursor-pointer text-center text-lg rounded-r-md px-16 py-8 bg-blue-600 whitespace-no-wrap text-white flex justify-center items-center"
          (click)="
            selectedOption == 1
              ? enAttenteByDate()
              : selectedOption == 2
              ? encourByDate()
              : arriverByDate()
          "
        >
          <mat-icon>done</mat-icon>
        </div>
      </div>
      <!-- spacer -->

      <!-- dispplay modes -->
      <div class="flex justify-end col-span-1">
        <div
          (click)="changePrefDisplay('table')"
          class="rounded-lg cursor-pointer p-3"
          style="width: 50px; height: 50px"
          [class]="
            displayMode != 'cards'
              ? 'bg-blue-900 text-white'
              : 'text-blue-900 border-2 border-blue-900'
          "
        >
          <mat-icon>reorder</mat-icon>
        </div>
        <div
          (click)="changePrefDisplay('cards')"
          class="rounded-lg cursor-pointer p-3 ml-3"
          style="width: 50px; height: 50px"
          [class]="
            displayMode != 'table'
              ? 'bg-blue-900 text-white'
              : 'text-blue-900 border-2 border-blue-900'
          "
        >
          <mat-icon>view_module</mat-icon>
        </div>
      </div>
    </div>
  </mat-expansion-panel>
  <!-- depart table  -->
  <div
    *ngIf="displayMode == 'table' && selectedOption == 1"
    class="md:px-4 py-8 w-full"
  >
    <div
      class="shadow rounded border-b border-gray-200"
      style="overflow: auto"
      [style]="panelOpenState ? 'height: 43vh' : 'height: 66vh'"
    >
      <table class="min-w-full bg-white">
        <thead class="bg-gray-800 text-white">
          <tr>
            <th class="text-left py-3 px-8 uppercase font-semibold text-sm">
              Départ
            </th>
            <th class="text-left py-3 px-8 uppercase font-semibold text-sm">
              Arrivée
            </th>
            <th class="text-left py-3 px-8 uppercase font-semibold text-sm">
              Référence
            </th>
            <th class="text-left py-3 px-8 uppercase font-semibold text-sm">
              Code de colis
            </th>
            <th class="text-left py-3 px-8 uppercase font-semibold text-sm">
              Date création
            </th>
            <th class="text-left py-3 px-8 uppercase font-semibold text-sm">
              désignation
            </th>
            <th
              *ngIf="userIsAllowedToDelete"
              class="text-left py-3 px-8 uppercase font-semibold text-sm"
            >
              Actions
            </th>
          </tr>
        </thead>
        <tbody class="text-gray-700">
          <tr
            class="hover:text-white hover:bg-gray-600 cursor-pointer transition"
            *ngFor="let colis of departColis; index as i"
            [class]="
              colis.isLate
                ? i % 2 != 0
                  ? 'bg-gray-200 urgentCard'
                  : 'urgentCard'
                : i % 2 != 0
                ? 'bg-gray-200 '
                : ''
            "
          >
            <td class="text-left py-3 px-4">
              {{ colis.Colis_Depart || "Non Défini" }}
            </td>
            <td class="text-left py-3 px-4">
              {{ colis.Colis_Arrive || "Non Défini" }}
            </td>
            <td class="text-left py-3 px-4">
              {{ colis.Colis_Ref || "Non Défini" }}
            </td>
            <td class="text-left py-3 px-4">
              {{ colis.Colis_Code }}
            </td>
            <td class="text-left py-3 px-4">
              {{ colis.Date_Create | date : "dd-MM-yyyy h:mm" }}
            </td>
            <td class="text-left py-3 px-4">
              {{ colis.Colis_Texte }}
            </td>
            <td
              *ngIf="userIsAllowedToDelete"
              class="text-center flex justify-evenly py-3 px-4"
            >
              <div
                (click)="toEdit(colis)"
                class="w-30 h-30 bg-blue-700 float-right justify-center items-center flex rounded-lg cursor-pointer text-center ml-4"
              >
                <mat-icon class="text-white text-base">edit</mat-icon>
              </div>
              <div
                (click)="toDelete(colis)"
                class="w-30 h-30 bg-red-700 float-right justify-center items-center flex rounded-lg cursor-pointer text-center"
              >
                <mat-icon class="text-white text-base">delete</mat-icon>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <!-- encour table  -->
  <div
    *ngIf="displayMode == 'table' && selectedOption == 2"
    class="md:px-4 py-8 w-full"
  >
    <div
      class="shadow rounded border-b border-gray-200"
      style="overflow: auto"
      [style]="panelOpenState ? 'height: 43vh' : 'height: 66vh'"
    >
      <table class="min-w-full bg-white">
        <thead class="bg-gray-800 text-white">
          <tr>
            <th class="text-left py-3 px-8 uppercase font-semibold text-sm">
              Départ
            </th>
            <th class="text-left py-3 px-8 uppercase font-semibold text-sm">
              Arrivée
            </th>
            <th class="text-left py-3 px-8 uppercase font-semibold text-sm">
              Référence
            </th>
            <th class="text-left py-3 px-8 uppercase font-semibold text-sm">
              Code de colis
            </th>
            <th class="text-left py-3 px-8 uppercase font-semibold text-sm">
              DATE CRÉATION
            </th>
            <th class="text-left py-3 px-8 uppercase font-semibold text-sm">
              Date départ
            </th>
            <th
              class="w-2/5 text-left py-3 px-8 uppercase font-semibold text-sm"
            >
              Circuit
            </th>
            <th class="text-left py-3 px-8 uppercase font-semibold text-sm">
              DÉSIGNATION
            </th>
          </tr>
        </thead>
        <tbody class="text-gray-700">
          <tr
            class="hover:text-white hover:bg-gray-600 transition cursor-pointer"
            *ngFor="let colis of encourColis; index as i"
            [class]="
              colis.isLate
                ? i % 2 != 0
                  ? 'bg-gray-200 urgentCard'
                  : 'urgentCard'
                : i % 2 != 0
                ? 'bg-gray-200 '
                : ''
            "
          >
            <td class="text-left py-3 px-4">
              {{ colis.Colis_Depart || "Non Défini" }}
            </td>
            <td class="text-left py-3 px-4">
              {{ colis.Colis_Arrive || "Non Défini" }}
            </td>
            <td class="text-left py-3 px-4">
              {{ colis.Colis_Ref || "Non Défini" }}
            </td>
            <td class="text-left py-3 px-4">
              {{ colis.Colis_Code }}
            </td>
            <td class="text-left py-3 px-4">
              {{ colis.Date_Create | date : "dd-MM-yyyy h:mm" }}
            </td>
            <td class="text-left py-3 px-4">
              {{ colis.Colis_DateDepart | date : "dd-MM-yyyy h:mm" }}
            </td>
            <td class="text-left py-3 px-4">
              <div class="flex">
                <ng-container *ngFor="let step of colis.track; index as is">
                  <div class="grid">
                    <span class="font-bold">{{ step.User_Id_Create }}</span>
                    <span>{{
                      step.Date_Create | date : "dd-MM-yyyy h:mm"
                    }}</span>
                  </div>
                  <div
                    *ngIf="is != colis.track.length - 1"
                    class="mx-3 text-red-700"
                  >
                    →
                  </div>
                </ng-container>
              </div>
            </td>
            <td class="text-left py-3 px-4">
              {{ colis.Colis_Texte }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <!-- arriver table  -->
  <div
    *ngIf="displayMode == 'table' && selectedOption == 3"
    class="md:px-4 py-8 w-full"
  >
    <div
      class="shadow rounded border-b border-gray-200"
      style="overflow: auto"
      [style]="panelOpenState ? 'height: 43vh' : 'height: 66vh'"
    >
      <table class="min-w-full bg-white">
        <thead class="bg-gray-800 text-white">
          <tr>
            <th class="text-left py-3 px-8 uppercase font-semibold text-sm">
              Départ
            </th>
            <th class="text-left py-3 px-8 uppercase font-semibold text-sm">
              Arrivée
            </th>
            <th class="text-left py-3 px-8 uppercase font-semibold text-sm">
              Référence
            </th>
            <th class="text-left py-3 px-8 uppercase font-semibold text-sm">
              Code de colis
            </th>
            <th class="text-left py-3 px-8 uppercase font-semibold text-sm">
              DATE CRÉATION
            </th>
            <th class="text-left py-3 px-8 uppercase font-semibold text-sm">
              Date départ
            </th>
            <th class="text-left py-3 px-8 uppercase font-semibold text-sm">
              Date arrivée
            </th>
            <th class="text-left py-3 px-8 uppercase font-semibold text-sm">
              DÉSIGNATION
            </th>
          </tr>
        </thead>
        <tbody class="text-gray-700">
          <tr
            class="hover:text-white hover:bg-gray-600 transition cursor-pointer"
            *ngFor="let colis of arriveColis; index as i"
            [class]="i % 2 != 0 ? 'bg-gray-200' : ''"
          >
            <td class="text-left py-3 px-4">
              {{ colis.Colis_Depart || "Non Défini" }}
            </td>
            <td class="text-left py-3 px-4">
              {{ colis.Colis_Arrive || "Non Défini" }}
            </td>
            <td class="text-left py-3 px-4">
              {{ colis.Colis_Ref || "Non Défini" }}
            </td>
            <td class="text-left py-3 px-4">
              {{ colis.Colis_Code }}
            </td>
            <td class="text-left py-3 px-4">
              {{ colis.Date_Create | date : "dd-MM-yyyy h:mm" }}
            </td>
            <td class="text-left py-3 px-4">
              {{ colis.Colis_DateDepart | date : "dd-MM-yyyy h:mm" }}
            </td>
            <td class="text-left py-3 px-4">
              {{ colis.Colis_DateArrive | date : "dd-MM-yyyy h:mm" }}
            </td>
            <td class="text-left py-3 px-4">
              {{ colis.Colis_Texte }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <!-- cards -->
  <div
    *ngIf="displayMode == 'cards'"
    class="grid overflow-y-scroll transition"
    [class]="
      selectedOption == 2
        ? 'grid-cols-2'
        : 'sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3'
    "
    [style]="panelOpenState ? 'height: 54.5vh' : 'height: 77.5vh'"
    style="margin-left: 13px"
  >
    <div
      *ngFor="
        let colis of selectedOption == 1
          ? departColis
          : selectedOption == 2
          ? encourColis
          : arriveColis
      "
      class="py-8 px-16"
    >
      <app-colis-card
        [colis]="colis"
        [selectedOption]="selectedOption"
        [userIsAllowedToDelete]="userIsAllowedToDelete"
        (Delete)="toDelete($event)"
        (Edit)="toEdit($event)"
      ></app-colis-card>
    </div>
  </div>
  <!-- modal -->
  <div
    [ngClass]="{ 'opacity-100 pointer-events-auto': confirmBarCode }"
    class="modal z-20 opacity-0 pointer-events-none fixed w-full h-full top-0 left-0 flex items-center justify-center transition"
  >
    <div
      class="modal-overlay absolute w-full h-full bg-gray-900 opacity-50"
    ></div>

    <div
      class="modal-container bg-white w-11/12 md:max-w-md mx-auto rounded shadow-lg z-50 overflow-y-auto"
    >
      <div
        class="modal-close absolute top-0 right-0 cursor-pointer flex flex-col items-center mt-4 mr-4 text-white text-sm z-50"
      ></div>

      <!-- Add margin if you want to see some of the overlay behind the modal-->
      <div class="modal-content py-30 text-left px-20">
        <!--Title-->
        <div class="flex justify-between items-center pb-20">
          <p class="text-2xl font-bold">Vous voulez soumettre ce code ?</p>
        </div>

        <div class="text-center pb-20 text-xl">{{ requestType }}</div>
        <div class="text-center pb-20 text-green-500 text-3xl">{{ Code }}</div>
        <div class="flex justify-end pt-2">
          <button
            class="px-30 bg-transparent p-3 rounded-lg text-indigo-500 hover:bg-gray-100 hover:text-indigo-400 mr-20"
            (click)="confirmBarCode = false"
          >
            Annuler
          </button>
          <button
            class="modal-close px-30 bg-indigo-500 p-3 rounded-lg cursor-pointer text-white hover:bg-indigo-400"
            (click)="submitBarCode()"
          >
            Confirmer
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- alerts -->
  <div
    role="alert"
    class="fixed bottom-2 right-2 w-2/6 opacity-0"
    [ngClass]="{ showAlert: showAlertSucc }"
  >
    <div class="bg-green-500 text-white font-bold rounded-t px-16 py-8">
      Success !
    </div>
    <div
      class="border border-t-0 border-green-400 rounded-b bg-green-100 px-16 py-8 text-green-700"
    >
      <p>les modifications ont été soumises avec succès !</p>
    </div>
  </div>
  <!-- alerts -->
  <div
    role="alert"
    class="fixed bottom-2 right-2 w-2/6 opacity-0"
    [ngClass]="{ showAlert: showAlertFail }"
  >
    <div class="bg-red-500 text-white font-bold rounded-t px-16 py-8">
      Error !
    </div>
    <div
      class="border border-t-0 border-red-400 rounded-b bg-red-100 px-16 py-8 text-red-700"
    >
      <p>Un problème est survenu, veuillez réessayer C-V-P</p>
    </div>
  </div>
  <!-- confirm Delete -->
  <div
    *ngIf="colisToEdit"
    class="min-w-screen h-screen fixed flex justify-center items-center inset-0 z-50 transition"
    [class]="
      openConfirmDeletePopover ? 'opacity-100' : 'opacity-0 pointer-events-none'
    "
  >
    <div class="absolute bg-black opacity-80 inset-0 z-0"></div>
    <div
      class="w-full max-w-lg p-5 relative mx-auto my-auto rounded-xl shadow-lg bg-white"
    >
      <!--content-->
      <div class="">
        <!--body-->
        <div class="text-center p-5 flex-auto justify-center">
          <svg
            class="w-25 h-25 -m-1 flex items-center text-red-500 mx-auto"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            ></path>
          </svg>
          <svg
            class="w-50 h-50 flex items-center text-red-500 mx-auto"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
              clip-rule="evenodd"
            />
          </svg>
          <h2 class="text-xl font-bold py-4">Es-tu sûr?</h2>
          <p class="text-lg text-gray-500 px-8">
            Voulez-vous vraiment supprimer ce colis
            <span class="text-green-700 font-bold"
              >"{{ colisToEdit.Colis_Code }}"</span
            >
            ? Ce processus ne peut pas être annulé
          </p>
        </div>
        <!--footer-->
        <div class="p-3 mt-2 text-center space-x-4 md:block">
          <button
            (click)="openConfirmDeletePopover = false"
            class="mb-2 md:mb-0 bg-white px-5 py-8 text-xl shadow-sm font-medium tracking-wider border text-gray-600 rounded-lg hover:shadow-lg hover:bg-gray-100"
          >
            Annuler
          </button>
          <button
            (click)="deleteColis()"
            class="mb-2 md:mb-0 bg-red-500 border border-red-500 px-5 py-8 text-xl shadow-sm font-medium tracking-wider text-white rounded-lg hover:shadow-lg hover:bg-red-600"
          >
            Supprimer
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- edit modal -->
  <div
    *ngIf="colisToEdit"
    class="min-w-screen h-screen fixed flex justify-center items-center inset-0 z-50 transition"
    [class]="openEditPopover ? 'opacity-100' : 'opacity-0 pointer-events-none'"
  >
    <div class="absolute bg-black opacity-80 inset-0 z-0"></div>
    <div
      class="z-10 flex flex-col sm:w-5/6 lg:w-1/2 max-w-2xl mx-auto rounded-lg border border-gray-300 shadow-xl bg-white p-4"
      [class]="colisToEdit.isLate ? 'urgentCard' : ''"
    >
      <span
        *ngIf="colisToEdit.isLate"
        class="text-red-600 font-bold flex items-center text-2xl px-12 pt-12"
        ><mat-icon>error_outline</mat-icon> En Retard
      </span>
      <div
        class="flex flex-row justify-between p-12 bg-white border-b border-gray-200 rounded-tl-lg rounded-tr-lg"
      >
        <p class="text-2xl font-bold m-0">
          Colis :
          <span class="text-green-500">{{ colisToEdit.Colis_Code }}</span>
        </p>
        <mat-icon class="cursor-pointer" (click)="closeEdit()">close</mat-icon>
      </div>
      <div class="flex flex-col px-6 py-5 bg-gray-50">
        <ng-container *ngIf="selectedOption == 1">
          <div class="text-md text-gray-700 mx-8 mb-2">
            Arrivée {{ colisToEdit.Colis_Arrive }}
          </div>
          <unilog-recherche
            *ngIf="colisToEdit.Colis_ArriveType == 0"
            appearance="outline"
            champsModel="Site_Code"
            champsAffiche="Site_Des"
            [ServerSideFiltering]="true"
            recherche="SitesColisA"
            [api]="generalService.api"
            placeholder="Arrivée"
            [(ngModel)]="colisToEdit.Colis_Arrive"
          >
          </unilog-recherche>
          <mat-form-field
            class="w-full"
            appearance="outline"
            *ngIf="colisToEdit.Colis_ArriveType == 1"
          >
            <input
              [(ngModel)]="colisToEdit.Colis_Arrive"
              type="text"
              matInput
              placeholder="Arrivée"
            />
          </mat-form-field>
          <mat-slide-toggle
            (change)="changeArriveType($event)"
            class="mb-3"
            [checked]="colisToEdit.Colis_ArriveType == 1"
            >Externe</mat-slide-toggle
          >
          <div class="text-md text-gray-700 mx-8 mb-2">Référence</div>
          <mat-form-field class="w-full" appearance="outline">
            <input
              [(ngModel)]="colisToEdit.Colis_Ref"
              type="text"
              matInput
              placeholder="Référence"
            />
          </mat-form-field>
          <div class="text-md text-gray-700 mx-8 mb-2">Désignation</div>
          <mat-form-field class="w-full" appearance="outline">
            <input
              [(ngModel)]="colisToEdit.Colis_Texte"
              type="text"
              matInput
              placeholder="Désignation"
            />
          </mat-form-field>
        </ng-container>
        <div class="text-md text-gray-700 mx-8 mb-2">Date du rappelle</div>

        <mat-form-field class="w-full" appearance="outline">
          <input
            matInput
            [matDatepicker]="dateRappel"
            [(ngModel)]="colisToEdit.Date_Rappel"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="dateRappel"
          ></mat-datepicker-toggle>
          <mat-datepicker #dateRappel></mat-datepicker>
        </mat-form-field>
        <div class="text-md text-gray-700 mx-8 mb-2">Texte du rappelle</div>
        <mat-form-field class="w-full" appearance="outline">
          <input
            [(ngModel)]="colisToEdit.Colis_Rappel"
            type="text"
            matInput
            placeholder="Texte du rappelle"
          />
        </mat-form-field>
      </div>
      <div
        class="flex flex-row items-center justify-between p-5 bg-white border-t border-gray-200 rounded-bl-lg rounded-br-lg"
      >
        <p
          (click)="closeEdit()"
          class="px-16 py-8 text-xl text-gray-600 rounded-lg hover:shadow cursor-pointer"
        >
          Annuler
        </p>
        <button
          (click)="updateColis()"
          class="px-16 py-8 text-white text-xl bg-blue-700 rounded"
        >
          Enregistrer
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Scan Code popever -->

<div
  class="fixed w-full h-full justify-center z-10 left-0 top-0"
  *ngIf="scanBarCode"
>
  <div class="w-full relative h-full">
    <div class="fixed w-full bg-black opacity-50 h-full"></div>
    <div class="imgScan fixed">
      <mat-icon
        class="text-red-500 float-right m-4 cursor-pointer"
        (click)="scanBarCode = false"
        >highlight_off</mat-icon
      >
      <span class="scanBarCode">Scan bar code</span>
    </div>
  </div>
  <input
    hideKeyboard
    type="text"
    #code
    id="hiddenInput"
    style="position: absolute; left: -1000px; top: -1000px"
    (paste)="scannedWithPm($event)"
    (change)="scannedWithPm($event)"
    (blur)="refocus()"
    autofocus
  />
</div>
